import type { Logger } from "@expert/logging";

import ky, { HTTPError } from "ky";

import type { DefaultPayload } from "./types";
import type { VerifyCustomerResult } from "./verifyCustomer";

import { defaultHeaders, defaultTimeoutInMS } from "../types";

type VerifyPasscodeForVerificationPayload = DefaultPayload & {
    mdn: string;
    passcode: string;
    transactionId: string;
};

export const verifyPasscodeForVerification = async (
    ssoAccessToken: string,
    payload: VerifyPasscodeForVerificationPayload,
    logger: Logger,
    apiBaseUrl: string,
) => {
    try {
        const url = `${apiBaseUrl}/api/device-activation/v1/verify-customer/verify-otp`;
        const resp = await ky.post(url, {
            headers: {
                ...defaultHeaders,
                Authorization: `Bearer ${ssoAccessToken}`,
            },
            json: payload,
            timeout: defaultTimeoutInMS,
        });

        const { accountMdns, activationFlowType, claimSummaries, token } = await resp.json<VerifyCustomerResult>();
        return { accountMdns, activationFlowType, claimSummaries, token };
    } catch (error) {
        logger.warn({ error }, "Solve Guide | Error: Could not verify customer with passcode (OTP).");

        let errorCode = "";
        let errorMessage = "";

        // ky 2 consumes the error body into `error.data` before throwing; `error.response.json()`
        // would always reject (ew#7426).
        if (error instanceof HTTPError) {
            if (typeof error.data === "object" && error.data !== null) {
                const errorJson = error.data as { code?: string; message?: string };
                errorCode = errorJson.code || "";
                errorMessage = errorJson.message || "";

                logger.info({ errorCode, errorMessage }, "Solve Guide | API returned error message");
            } else {
                logger.warn(
                    { httpStatus: error.response.status },
                    "Solve Guide | verify-otp error body was not a JSON object",
                );
            }
        }

        return {
            accountMdns: [],
            activationFlowType: undefined,
            claimSummaries: [],
            token: undefined,
            errorCode,
            errorMessage,
        };
    }
};
